<template>
    <div class="detail-wrapper">
        <div class="detail-inner flex-style-column">
                <div class="top-wrapper flex-style-row with-full-size">
                    <div class="checkbox-wrapper">
                        <p class="checkbox-label">노출 여부</p>
                        <input v-model="innerManual.showYn" class="checked" type="checkbox" />
                    </div>
                    <input
                        v-model="innerManual.title"
                        type="text"
                        class="with-full-size border-style-radius manual-title-input-style"
                        placeholder="제목을 입력하세요"
                    />
                </div>
                <template v-if="allowContentFields">
                    <div class="with-full-size manual-title-content-style">
                        <quill-editor
                            ref="editor"
                            :options="options"
                            v-model="innerManual.content"
                            class="quill-editor-box"
                        />
                    </div>
                    <div class="sub-content-block">
                        <p class="sub-content-label">부가 내용 (모바일)</p>
                        <textarea
                            v-model="innerManual.subContent"
                            class="sub-content-textarea"
                            rows="8"
                            placeholder="모바일용 부가 내용을 입력하세요"
                        />
                    </div>
                </template>
                <div class="detail-button-wrapper">
                    <button
                        v-if="clickMenuDepth === 2"
                        type="button"
                        class="button-complete-style"
                        @click="completeButton"
                    >
                        작성완료
                    </button>
                    <button
                        v-if="clickMenuDepth === 3"
                        type="button"
                        class="button-update-style"
                        @click="updateButton('N')"
                    >
                        수정완료
                    </button>
                    <button
                        v-if="clickMenuDepth === 3"
                        type="button"
                        class="button-delete-style"
                        @click="updateButton('Y')"
                    >
                        삭제
                    </button>
                </div>
        </div>
    </div>
</template>

<script>
/**
 * 모바일 메뉴얼 전용 상세 (NewManualDetail 미사용)
 * manualWriteData ↔ innerManual 동기 시 참조 공유로 인한 watch 루프를 막기 위해 복사·동등 비교 적용
 */
export default {
    name: "MobileManualDetail",
    props: {
        manual: {
            type: Object,
            default: () => ({}),
        },
        manualWriteData: {
            type: Object,
            default: () => ({}),
        },
        clickMenuDepth: {
            type: Number,
            default: undefined,
        },
        /** false: 2뎁스(제목·노출만). true: 3뎁스만 본문·부가내용 편집 */
        allowContentFields: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            /** 부모 manualWriteData 반영 중에는 inner → emit 금지 (루프 방지) */
            syncingFromProp: false,
            innerManual: {
                title: undefined,
                content: undefined,
                subContent: "",
                showYn: false,
                parentId: undefined,
            },
            options: {
                modules: {
                    toolbar: {
                        container: [
                            ["bold", "italic", "underline", "strike"],
                            ["blockquote", "code-block"],
                            [{ header: 1 }, { header: 2 }],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ script: "sub" }, { script: "super" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            [{ direction: "rtl" }],
                            [{ size: ["small", false, "large", "huge"] }],
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            [{ color: [] }, { background: [] }],
                            [{ font: [] }],
                            [{ align: [] }],
                            ["clean"],
                            ["image"],
                        ],
                    },
                    imageDrop: true,
                    imageResize: {
                        modules: ["Resize", "DisplaySize"],
                    },
                },
            },
        }
    },
    methods: {
        payloadFromProp(nv) {
            if (!nv || typeof nv !== "object") return null
            const allow = this.allowContentFields
            return {
                title: nv.title,
                content: allow ? nv.content : undefined,
                subContent: allow ? (nv.subContent != null ? nv.subContent : "") : "",
                showYn: nv.showYn === true || nv.showYn === "Y",
                parentId: nv.parentId,
            }
        },
        normField(v) {
            if (v === undefined || v === null) return null
            if (typeof v === "string" && v.trim() === "") return null
            return v
        },
        sameInner(a, b) {
            const p = (x) => (x == null ? null : x)
            const head =
                this.normField(a.title) === this.normField(b.title) &&
                !!a.showYn === !!b.showYn &&
                p(a.parentId) === p(b.parentId)
            if (!this.allowContentFields) return head
            return (
                head &&
                this.normField(a.content) === this.normField(b.content) &&
                this.normField(a.subContent) === this.normField(b.subContent)
            )
        },
        emitWriteData() {
            const payload = {
                title: this.innerManual.title,
                showYn: this.innerManual.showYn,
                parentId: this.innerManual.parentId,
            }
            if (this.allowContentFields) {
                payload.content = this.innerManual.content
                payload.subContent = this.innerManual.subContent
            } else {
                payload.content = undefined
                payload.subContent = ""
            }
            this.$emit("change-write-data", payload)
        },
        completeButton() {
            if (!this.innerManual.title) {
                this.$alert("제목을 입력해주세요")
                return
            }
            this.$confirm("저장하시겠습니까?")
                .then(() => this.$emit("insert-data-rq"))
                .catch(() => {})
        },
        updateButton(deleteYn) {
            this.$confirm(`${deleteYn === "Y" ? "삭제" : "수정"}하시겠습니까?`)
                .then(() => this.$emit("update-data-rq", deleteYn))
                .catch(() => {})
        },
    },
    watch: {
        manualWriteData: {
            deep: true,
            immediate: true,
            handler(nv) {
                const next = this.payloadFromProp(nv)
                if (!next) return
                if (this.sameInner(next, this.innerManual)) return
                this.syncingFromProp = true
                this.innerManual = { ...next }
                this.$nextTick(() => {
                    this.syncingFromProp = false
                })
            },
        },
        innerManual: {
            deep: true,
            immediate: false,
            handler() {
                if (this.syncingFromProp) return
                this.emitWriteData()
            },
        },
        allowContentFields(nv) {
            const next = this.payloadFromProp(this.manualWriteData)
            if (!next) return
            if (this.sameInner(next, this.innerManual)) return
            this.syncingFromProp = true
            this.innerManual = { ...next }
            this.$nextTick(() => {
                this.syncingFromProp = false
            })
        },
    },
}
</script>

<style scoped>
.border-style-radius {
    border: 1px solid #cccccc;
    border-radius: 5px;
}
.with-full-size {
    width: 100%;
}
.flex-style-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.flex-style-row {
    display: flex;
}
.detail-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.detail-inner {
    height: 100%;
}
.checkbox-wrapper {
    align-items: center;
    padding: 0px;
    width: 12%;
    display: flex;
    align-items: center;
}
.checkbox-label {
    margin-bottom: 0px;
    margin-right: 5px;
}
input[type="checkbox"] {
    cursor: pointer;
    border: 2px solid #0c98fe;
    border-radius: 3px;
    background-color: white;
    width: 20px;
    height: 20px;
}
.top-wrapper {
    margin-bottom: 20px;
}
.manual-title-input-style {
    height: 50px;
    width: 100%;
    padding-left: 12px;
}
.manual-title-content-style {
    height: 100%;
    width: 100%;
    min-height: 200px;
    overflow: auto;
    white-space: nowrap;
    resize: none;
}
.quill-editor-box {
    width: 100%;
    height: calc(100% - 50px);
    min-height: 220px;
    background-color: #ffffff;
    padding: 0px;
}
.sub-content-block {
    width: 100%;
    margin-top: 16px;
    flex-shrink: 0;
}
.sub-content-label {
    margin: 0 0 8px 0;
    font-weight: 600;
    font-size: 14px;
}
.sub-content-textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 14px;
    resize: vertical;
    min-height: 120px;
}
.detail-button-wrapper {
    display: flex;
    width: 100%;
}
.button-complete-style {
    background-color: #42b983 !important;
    border-color: #42b983 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}
.button-update-style {
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}
.button-delete-style {
    background-color: red !important;
    border-color: red !important;
    padding: 6px 0;
    width: 100%;
    border-radius: 5px;
    color: #eeeeee;
    margin-top: 10px;
    margin-left: 20px;
}
>>> .ql-editor {
    overflow: auto;
    white-space: nowrap;
}
</style>
